import React from 'react';
import ReactDOM from 'react-dom';
import { SnackbarProvider } from 'notistack';
import App from './App';

ReactDOM.render(
  <SnackbarProvider
    maxSnack={3}
    hideIconVariant
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    <App />
  </SnackbarProvider>,
  document.getElementById('root')
);
